import { BottomNav } from "./BottomNav";

export default BottomNav;
